import React from 'react';
import PropTypes from 'prop-types';

import { Button, Form } from 'react-bootstrap';
import classNames from 'classnames';
import { css, StyleSheet } from 'aphrodite';
import { Table } from 'react-bootstrap';

import { backgroundGrey, grape, lightRed } from 'lib/css/colors';
import Container from 'components/shared/Container';
import pointerOnHover from 'lib/css/pointerOnHover';
import VerificationStatusIcon from 'components/global_products/detail_view/VerificationStatusIcon';

function ProductOutliersFeedbackTable({
  products,
  globalProductId,
  selectedList,
  setSelectedList,
}) {
  return (
    <Container>
      <Table className={css(styles.tableText)}>
        <thead className={css(styles.thead)}>
          <tr>
            <th>
              <Form.Check
                type="checkbox"
                checked={products?.length > 0 && selectedList?.length === products?.length}
                onChange={e => setSelectedList(e.target.checked ? [...products] : [])}
              />
            </th>
            <th>Entity Type</th>
            <th>Entity Name</th>
            <th>SKU</th>
            <th>Product Name</th>
            <th>Core 11</th>
            <th>Pack Size</th>
            <th>Brand</th>
            <th>CD Product Score</th>
            <th>Feedback</th>
            <th />
            <th />
          </tr>
        </thead>
        <tbody className={css(styles.tbody)}>
          {products?.length ? (
            products?.map((product, index) => (
              <tr
                key={index}
                className={classNames({
                  [css(styles.rowRed)]: product.cluster_by_correlation === -1,
                })}
              >
                <td>
                  <Form.Check
                    type="checkbox"
                    checked={selectedList?.some(
                      selectedProduct => selectedProduct?.id === product.id,
                    )}
                    onChange={e => {
                      if (e.target.checked) {
                        if (
                          !selectedList.some(
                            selectedProduct =>
                              selectedProduct.id === product.id &&
                              selectedProduct.product_type === product.product_type,
                          )
                        ) {
                          setSelectedList([...selectedList, product]);
                        }
                      } else {
                        setSelectedList(
                          selectedList.filter(selectedProduct => selectedProduct.id !== product.id),
                        );
                      }
                    }}
                  />
                </td>
                <td>{product.entity_type}</td>
                <td>{product.entity_name}</td>
                <td>{product.sku}</td>
                <td>{product.name}</td>
                <td>{product.core_11 || '-'}</td>
                <td>{product.pack_size || '-'}</td>
                <td>{product.brand_name || '-'}</td>
                <td>{product.fsa_score || 0}%</td>
                <td>{product.feedback}</td>
                <td className="text-center">
                  <VerificationStatusIcon
                    verificationStatus={product.verification_status}
                    aiSuggestedVerification={product.ai_suggested_verification}
                  />
                </td>
                <td className="d-flex">
                  <Button
                    variant="link"
                    className={classNames(css(styles.button), pointerOnHover)}
                    onClick={() => {
                      window.open(
                        `/global-product-detail/${globalProductId}/` +
                          `${product.id}/${product.entity_type.toLowerCase()}`,
                        '_blank',
                      );
                    }}
                  >
                    View
                  </Button>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="100%" className="text-center">
                No products found.
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </Container>
  );
}

const styles = StyleSheet.create({
  tableText: {
    fontSize: '0.95rem',
  },
  thead: {
    position: 'sticky',
    top: 0,
    backgroundColor: backgroundGrey,
    zIndex: 1,
  },
  tbody: {
    position: 'relative',
  },
  button: {
    color: grape,
  },
  rowRed: {
    backgroundColor: lightRed,
  },
});

ProductOutliersFeedbackTable.propTypes = {
  products: PropTypes.array,
  globalProductId: PropTypes.number,
  selectedList: PropTypes.array,
  setSelectedList: PropTypes.func,
};

export default ProductOutliersFeedbackTable;
